const features = [
  {
    icon: 'ri-live-line',
    title: '高清直播',
    description: '支持4K超高清画质直播，HDR技术还原真实色彩，低延迟流畅播放，带来沉浸式观看体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多重安全保护机制，实名认证与智能内容审核双管齐下，保障用户隐私与平台环境。',
  },
  {
    icon: 'ri-group-line',
    title: '实时互动',
    description: '弹幕聊天、虚拟礼物、连麦互动等多种交流方式，让您与主播零距离沟通。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持Web、iOS、Android多平台无缝切换，随时随地享受直播娱乐内容。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif mb-3">
            为什么选择<strong>直播互动</strong>
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            我们致力于打造最优质的直播互动平台，让每一次观看都成为享受
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-lg p-6 hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}